import {
  Studio,
  StudioCursorConnection,
} from '@definitions/types/symfonyTypes'

import { parseStudiosResponse } from '../../api/symfony/parsers/graphqlParsers'

/**
 * Prepares studios from GraphQL cursor connection response
 * @param studios - The GraphQL cursor connection response
 * @returns Array of Studio objects, empty array if invalid or null
 */
export function prepareStudios(
  studios: StudioCursorConnection | null | undefined
): Studio[] {
  return parseStudiosResponse(studios)
}
